<template>
  <v-container class="container">
    <div class="d-flex align-center mb-6">
      <div :class="step !== '가입완료' ? 'active' : 'inactive'">회원가입</div>
      <v-icon>mdi-chevron-right</v-icon>
      <div :class="step === '가입완료' ? 'active' : 'inactive'">가입완료</div>
    </div>

    <UserInfo
      :nextStep="
        () => {
          handleStepChange(!leadId ? '업체정보' : '선택정보');
          pushDataLayer({
            event: 'clickNextBtn',
            page: 'signup',
            objectSection: 'signupForm',
            objectType: 'button',
            objectId: 'next',
            objectName: '다음',
            step: 1,
          });
        }
      "
      :step.sync="step"
      :form.sync="form"
      v-if="step === '회원가입'" />
    <StoreInfo
      :prevStep="
        () => {
          handleStepChange('회원가입');
          pushDataLayer({
            event: 'clickBackBtn',
            page: 'signup',
            objectSection: 'signupForm',
            objectType: 'button',
            objectId: 'back',
            objectName: '이전',
            step: 2,
          });
        }
      "
      :nextStep="
        () => {
          handleStepChange('선택정보');
          pushDataLayer({
            event: 'clickNextBtn',
            page: 'signup',
            objectSection: 'signupForm',
            objectType: 'button',
            objectId: 'next',
            objectName: '다음',
            step: 2,
          });
        }
      "
      :step.sync="step"
      :form.sync="form"
      v-if="step === '업체정보'" />
    <OptionalInfo
      :nextStep="() => handleStepChange('가입완료')"
      :step.sync="step"
      :form.sync="form"
      v-if="step === '선택정보'" />
    <RegisterDone :step.sync="step" :form.sync="form" v-if="step === '가입완료'" />
  </v-container>
</template>

<script>
import userMixin from '@/components/shared/userMixin';
import UserInfo from '@/components/company/signup/UserInfo.vue';
import StoreInfo from '@/components/company/signup/StoreInfo.vue';
import OptionalInfo from '@/components/company/signup/OptionalInfo.vue';
import RegisterDone from '@/components/company/signup/RegisterDone.vue';

import { pushDataLayer } from '@/utils';

export default {
  name: 'MembersSignup',
  mixins: [userMixin],
  components: {
    UserInfo,
    StoreInfo,
    OptionalInfo,
    RegisterDone,
  },
  data() {
    return {
      step: '회원가입',
      form: {
        email: '',
        password: '',
        password_confirmed: '',
        name: this.$route.query.companyName || '',
        x: this.$route.query.x || '',
        y: this.$route.query.y || '',
        type: 'STORE',
        contact: '',
        isPrivacyAgreed: false,
        isMarketingAgreed: false,
        route: 'None',
        recommended:
          this.$route.query.event === 'first_subscription'
            ? '첫 구독 3개월 20% 할인'
            : this.$route.query.recommended || '',
      },

      showPassword: false,
    };
  },

  computed: {
    leadId() {
      const queryParams = this.$route.query;

      if (queryParams.leadId) {
        return queryParams.leadId;
      }

      return null;
    },
  },

  watch: {
    step: {
      handler(newVal) {
        console.log('@step', newVal);
        if (newVal === '회원가입') {
          pushDataLayer({
            event: 'viewSignup',
            isLeadCompleted: !!this.leadId,
            step: 1,
          });
        } else if (newVal === '선택정보') {
          pushDataLayer({
            event: 'viewSignup',
            isLeadCompleted: !!this.leadId,
            step: 2,
          });
        } else if (newVal === '가입완료') {
          pushDataLayer({
            event: 'viewSignup',
            isLeadCompleted: !!this.leadId,
            step: 3,
          });
        }
      },
      immediate: true,
    },

    'form.type': {
      handler(newVal) {
        if (newVal === 'STORE' && this.$route.query.event === 'first_subscription') {
          this.form.recommended = '첫 구독 3개월 20% 할인';
        } else {
          this.form.recommended = this.$route.query.recommended || '';
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleStepChange(newStep) {
      window.scrollTo(0, 0);
      this.step = newStep;
    },
    pushDataLayer,
  },
  created() {
    if (this.userIsAuthenticated) {
      this.$router.push('/company/report');
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/form.scss';
@import '../../assets/scss/custom';

.container {
  width: 375px;
  padding: 24px;
}

.active {
  color: var(--primary_light, #ea2a3a);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.inactive {
  color: #9b9b9b;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
